import { useMemo } from 'react';
import NarrativeTypes from '~/constants/vdp/narrativeTypes';
import { useConfiguration } from '~/context/common/StaticContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import { Narrative } from '~/contracts/vdp/Narratives';
import useIsInVaultExperiment from './useIsInVaultExperiment';

export default function useGetVaultWhyBuyNarrative(): Narrative {
  const {
    VaultWhyBuyNarrativeConfig: {
      bucket: { control = '', treatment = '' } = {}
    } = {}
  } = useConfiguration();
  const { narratives } = useGetVehicleDetails();
  const isInVaultExperiment = useIsInVaultExperiment();

  // Treatment users fall back to control if treatment narrative doesn't exist
  const primaryVersion = isInVaultExperiment ? treatment : control;
  const fallbackVersion = isInVaultExperiment ? control : '';

  return useMemo(() => {
    if (!narratives) return {};

    const findNarrative = (version: string) =>
      narratives.find(
        n =>
          n?.narrativeType === NarrativeTypes.VIN_WHY_BUY &&
          n?.narrativeVersion === version
      );

    const primary = primaryVersion ? findNarrative(primaryVersion) : undefined;
    const fallback = fallbackVersion
      ? findNarrative(fallbackVersion)
      : undefined;

    return primary ?? fallback ?? {};
  }, [fallbackVersion, narratives, primaryVersion]);
}
